import { useMemo } from 'react';
import React from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';

interface AdvancePaymentsEntry {
  id  : string, 
  business_id: string, 
  advance_id: string, 
  amount: number,
  currency: string,
  effective_at: string,
  due_at: string,
  status: string
}

interface AdvancePaymentsTableProps {
  advancePaymentsData: { data: AdvancePaymentsEntry[] }; // Ensure this matches the type you're passing
}

const AdvancePaymentsTable: React.FC<AdvancePaymentsTableProps> = ({ advancePaymentsData }) => {
  // Memoized columns to prevent re-creation on re-renders
  const columns = useMemo<MRT_ColumnDef<AdvancePaymentsEntry>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'ID',
        size: 100,
    },
    {
        accessorKey: 'business_id',
        header: 'Business ID',
        size: 100
    },
    {
        accessorKey: 'advance_id',
        header: 'Advance ID',
        size: 100
    },
    {
        accessorKey: 'amount',
        header: 'Amount',
        size: 100,
        Cell: ({ row }) => `${row.original.currency.toUpperCase()} ${(row.original.amount / 100).toFixed(2)}`,

    },
    {
        accessorKey: 'effective_at',
        header: 'Effective At',
        size: 100
    },
    {
        accessorKey: 'due_at',
        header: 'Due at',
        size: 100
    },
    {
        accessorKey: 'status',
        header: 'Status',
        size: 100,
    }
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: advancePaymentsData.data, // Matches the shape of your updated webhookData
    initialState: { columnVisibility: {  payout_bank_account_id:false, missing_agreements: false, business_id: false, offer_id:false, paymenets_start_at:false, outstanding_balance:false} }, 
  });

  return <MaterialReactTable table={table} />;
};

export default AdvancePaymentsTable;
